
import store from '@/store';
import {defineComponent} from 'vue';
import UserInfoDto from "@/dto/UserInfoDto";
import {Modal} from "bootstrap";
import PasswordUtils from "@/utils/PasswordUtils";
import LoadingUtils from "@/utils/LoadingUtils";
import TWebKaiinJoho from "@/entity/TWebKaiinJoho";
import ValidateUtils from "@/utils/ValidateUtils";
import MMailTeikeibun from "@/entity/MMailTeikeibun";
import Dialog from "@/utils/Dialog";

export default defineComponent({
  name: 'UserRegisterInfoView',
  components: {},
  async created() {
    this.axios.get('/getConfig', {params: {keys: [
          'keitai_kaisha_docomo',
          'keitai_kaisha_au',
          'keitai_kaisha_softbank',
          'keitai_kaisha_rakuten',
          'mail_domain',
          'pwset_url',
          'pwset_url_kigen',
          'kakunin_cd_kigen']}}).then((res) => {
      this.configs = res.data as { [key: string]: string }
      this.axios.get('/getEnv', {params: {keys: [
            'env.userRegister.pop.email']}}).then((res) => {
        const env = res.data as { [key: string]: string }
        this.mailAddress = env['env.userRegister.pop.email']
        this.mailto = 'mailto:' + this.mailAddress + '?subject=%E7%99%BB%E9%8C%B2%E4%BE%9D%E9%A0%BC&body='
      }).catch()
    }).catch()
    //env.userRegister.pop.email

  },
  methods:{
    copy(){
      navigator.clipboard.writeText(this.mailAddress)
      Dialog.info('メールアドレスをコピーしました。')
    }
  },
  data(){
    return {
      title: 'Webユーザー登録のご案内',
      configs: {} as { [key: string]: string },
      mailTemplate: {} as MMailTeikeibun,
      mailAddress: '' as string,
      mailto: '',
      sendDone: false,
      canSendResult: false,
      mailMessage: ''
    }
  },
  computed:{

  }
});
